// removed by extract-text-webpack-plugin
module.exports = {"actions":"actions_IOcuC"};


//////////////////
// WEBPACK FOOTER
// ./app/components/giftcard/styles.scss
// module id = 511
// module chunks = 1